import { Component } from '@angular/core';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Cell-Komponente für die Status-Spalte in der Announcement-Tabelle.
 *
 * Zeigt den berechneten Status als Text an (Entwurf, Geplant, Aktiv, Deaktiviert, Abgelaufen).
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-status-cell',
  standalone: true,
  imports: [],
  templateUrl: './status-cell.component.html',
  styleUrls: ['./status-cell.component.scss'],
})
export class StatusCellComponent extends BaseCellComponent<AnnouncementTableItem> {}
